import { render, staticRenderFns } from "./YouTubeActionForm.vue?vue&type=template&id=8e1609b6&scoped=true"
import script from "./YouTubeActionForm.vue?vue&type=script&lang=js"
export * from "./YouTubeActionForm.vue?vue&type=script&lang=js"
import style0 from "./YouTubeActionForm.vue?vue&type=style&index=0&id=8e1609b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1609b6",
  null
  
)

export default component.exports